import styled from "styled-components";

export const Card = styled.div`
    display: flex;
    flex-direction: column;

    height: 100%;

    padding: 32px;

    background: rgba(255, 255, 255, .03);

    border: 1px solid rgba(255, 255, 255, .06);

    border-radius: ${({ theme }) => theme.borderRadius.lg};

    transition:
        transform .3s ease,
        border-color .3s ease,
        box-shadow .3s ease;

    cursor: default;

    &:hover {
        transform: translateY(-6px);

        border-color: ${({ theme }) => theme.colors.primary};

        box-shadow: 0 18px 45px rgba(0,0,0,.25);
    }
`;

export const Icon = styled.div`
    width: 64px;
    height: 64px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-bottom: 24px;

    border-radius: 16px;

    background: rgba(127, 191, 208, .12);

    font-size: 30px;
`;

export const Title = styled.h3`
    color: ${({ theme }) => theme.colors.white};

    font-size: 24px;

    font-weight: 600;

    margin-bottom: 16px;
`;

export const Description = styled.p`
    color: ${({ theme }) => theme.colors.gray};

    line-height: 1.7;

    flex: 1;
`;

export const Footer = styled.div`
    margin-top: 32px;
`;

export const LearnMore = styled.a`
    display: inline-flex;
    align-items: center;
    gap: .5rem;

    color: ${({ theme }) => theme.colors.primary};

    font-weight: 600;
    text-decoration: none;

    transition: .3s ease;

    svg {
        transition: transform .3s ease;
    }

    ${Card}:hover &{
        letter-spacing: .5px;
    }

    ${Card}:hover svg {
        transform: translateX(6px);
    }
`;